import Vue from 'vue';
import Router from 'vue-router';
import ErrorPage from '@/components/ErrorPage';
import Mega from '@/components/MegaWidget';

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/programme',
            alias: '/program',
            name: 'Mega',
            component: Mega,
            props: { widget: 'program'}
        },
        {
            path: '/vue-generale',
            alias: '/general-view',
            name: 'General',
            component: Mega,
            props: { widget: 'digital-model', mode: 'general' }
        },
        {
            path: '/maquette-3d',
            alias: '/digital-model',
            name: 'DigitalModel',
            component: Mega,
            props: { widget: 'digital-model', mode: 'digital-model' }
        },
        {
            path: '/plan-de-masse',
            alias: '/ground-plan',
            name: 'Ground',
            component: Mega,
            props: { widget: 'digital-model', mode: 'ground-plan' }
        },
        {
            path: '/vue-etages',
            alias: '/cutaway-view',
            name: 'Cutaway',
            component: Mega,
            props: { widget: 'cutaway' }
        },
        {
            path: '/vue-drone',
            alias: '/drone-view',
            name: 'Drone',
            component: Mega,
            props: { widget: 'drone-view' }
        },
        {
            path: '/vue-exterieure',
            alias: '/drone-floor-view',
            name: 'Drone-floor',
            component: Mega,
            props: { widget: 'drone-floor-view' }
        },
        {
            path: '/visite-virtuelle',
            alias: '/virtual-tour',
            name: 'Tour',
            component: Mega,
            props: { widget: 'virtual-tour' }
        },
        {
            path: '/lot',
            name: 'Plot',
            component: Mega,
            props: { widget: 'plot' }
        },
        {
            path: '/plan-2d',
            alias: '/2d-plan',
            name: 'Plan',
            component: Mega,
            props: { widget: '2d-plan' }
        },
        {
            path: '/plan-3d',
            alias: '/3d-plan',
            name: 'ThreeD',
            component: Mega,
            props: { widget: '3d-plan' }
        },
        {
            path: '/animation',
            name: 'video',
            component: Mega,
            props: { widget: 'animation' }
        },
        {
            path: '/carrousel',
            alias: '/carousel',
            name: 'Carousel',
            component: Mega,
            props: { widget: 'carousel' }
        },
        {
            path: '/carrousel-lot',
            alias: '/lot-carousel',
            name: 'Plot carousel',
            component: Mega,
            props: { widget: 'carousel-lot' }
        },
        {
            path: '/plan-de-quartier',
            alias: '/map',
            name: 'Map',
            component: Mega,
            props: { widget: 'map-view' }
        },
        {
            path: '/visites-temoins',
            alias: '/virtual-tours',
            name: 'TourModels',
            component: Mega,
            props: { widget: 'models' }
        },
        {
            path: '/perspective',
            name: 'Perspective',
            component: Mega,
            props: { widget: 'perspective' }
        },
        {
            path: '/video-de-quartier',
            alias: '/district-video',
            name: 'DistrictVideo',
            component: Mega,
            props: { widget: 'district-video' }
        },
        { 
            path: '/grille-de-lot',
            alias: '/plot-grid',
            name: 'PlotGrid',
            component: Mega,
            props: { widget: 'plot-grid' }
        },
        {
            path: '/documents',
            name: 'Documentation',
            component: Mega,
            props: { widget: 'documentation' }
        },
        {
            path: '/visite-configurable',
            alias: '/configurable-tour',
            name: 'ConfigurableTour',
            component: Mega,
            props: { widget: 'configurable-tour' }
        },
        {
            path: '*',
            component: ErrorPage
        }
    ]
});


// WEBPACK FOOTER //
// ./src/router/index.js